module.exports = __webpack_public_path__ + "static/media/ProximaNova-Regular.0ded48dd.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ProximaNova-Regular.eot
// module id = 3528
// module chunks = 70